(function () {
  const sections = document.querySelectorAll(".koffi-tst");
  if (!sections.length) return;

  const prefersReduced =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function readNumberCSSVar(el, name, fallback) {
    const v = (getComputedStyle(el).getPropertyValue(name) || "").trim();
    const n = Number(v);
    return Number.isFinite(n) && n > 0 ? n : fallback;
  }

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function now() {
    return (typeof performance !== "undefined" && performance.now) ? performance.now() : Date.now();
  }

  sections.forEach((section) => {
    const mode = section.dataset.mode || "slider";
    if (mode !== "slider") return;

    const track = section.querySelector("[data-tst-track]");
    if (!track) return;

    const btnPrev = section.querySelector("[data-tst-prev]");
    const btnNext = section.querySelector("[data-tst-next]");
    const dotsWrap = section.querySelector("[data-tst-dots]");

    const cards = Array.from(track.querySelectorAll(".koffi-tst__card"));
    if (!cards.length) return;

    // ---- Derived layout values ----
    function getPerView() {
      const isMobile = window.matchMedia("(max-width: 989px)").matches;
      const desktop = readNumberCSSVar(section, "--koffi-perview-desktop", 3);
      const mobile = readNumberCSSVar(section, "--koffi-perview-mobile", 1);
      return clamp(isMobile ? mobile : desktop, 1, 6);
    }

    function getStep() {
      const first = cards[0];
      const rect = first.getBoundingClientRect();
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
      return rect.width + gap;
    }

    let perView = getPerView();
    let step = getStep();
    let pageCount = Math.ceil(cards.length / perView);

    function pageStepPx() {
      return step * perView;
    }

    function pageFromScroll() {
      const ps = pageStepPx() || 1;
      const idx = Math.round(track.scrollLeft / ps);
      return clamp(idx, 0, pageCount - 1);
    }

    // ---- State ----
    let activePage = 0;
    let dots = [];

    // This prevents scroll handler from fighting our "next/prev" updates
    let isProgrammatic = false;
    let settleTimer = null;
    let lastProgrammaticAt = 0;

    function setDots(page) {
      if (!dots.length) return;
      dots.forEach((d, i) => d.classList.toggle("is-on", i === page));
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = "";
      dots = [];

      for (let i = 0; i < pageCount; i++) {
        const d = document.createElement("button");
        d.type = "button";
        d.className = "koffi-tst__dot" + (i === 0 ? " is-on" : "");
        d.setAttribute("aria-label", `Go to testimonials page ${i + 1}`);
        d.addEventListener("click", () => {
          scrollToPage(i, prefersReduced ? "auto" : "smooth");
          restartAutoplay();
        });
        dotsWrap.appendChild(d);
        dots.push(d);
      }
    }

    function lockDuringScroll() {
      isProgrammatic = true;
      lastProgrammaticAt = now();

      if (settleTimer) window.clearTimeout(settleTimer);

      // Unlock when scrolling has "settled"
      settleTimer = window.setTimeout(() => {
        isProgrammatic = false;

        // Snap dot state to the final page after smooth scroll ends
        const p = pageFromScroll();
        if (p !== activePage) {
          activePage = p;
          setDots(activePage);
        }
      }, prefersReduced ? 0 : 240);
    }

    function scrollToPage(page, behavior) {
      const p = clamp(page, 0, pageCount - 1);
      const left = pageStepPx() * p;

      // Update UI immediately (no flicker)
      activePage = p;
      setDots(activePage);

      lockDuringScroll();
      track.scrollTo({ left, behavior });
    }

    function recalc(keepPage = true) {
      perView = getPerView();
      step = getStep();
      pageCount = Math.ceil(cards.length / perView);

      buildDots();

      if (!keepPage) activePage = 0;
      activePage = clamp(activePage, 0, pageCount - 1);
      setDots(activePage);
    }

    // ---- Scroll listener (page sync) ----
    let raf = null;
    track.addEventListener(
      "scroll",
      () => {
        // If we started a programmatic scroll recently, ignore noisy updates
        if (isProgrammatic) return;

        if (raf) return;
        raf = requestAnimationFrame(() => {
          raf = null;

          // Extra guard: ignore micro-scroll events right after we triggered scrollTo
          if (now() - lastProgrammaticAt < 120) return;

          const p = pageFromScroll();
          if (p !== activePage) {
            activePage = p;
            setDots(activePage);
          }
        });
      },
      { passive: true }
    );

    // ---- Controls (by page) ----
    function prevPage() {
      scrollToPage(activePage - 1, prefersReduced ? "auto" : "smooth");
      restartAutoplay();
    }

    function nextPage() {
      const next = (activePage + 1) % pageCount;
      scrollToPage(next, prefersReduced ? "auto" : "smooth");
      restartAutoplay();
    }

    if (btnPrev) btnPrev.addEventListener("click", prevPage);
    if (btnNext) btnNext.addEventListener("click", nextPage);

    // ---- Autoplay (by page) ----
    const autoplay = section.dataset.autoplay === "true";
    const interval = Math.max(1500, Number(section.dataset.interval || 4500));
    const pauseHover = section.dataset.pauseHover === "true";

    let timer = null;
    let paused = false;

    function startAutoplay() {
      if (!autoplay || prefersReduced || pageCount < 2) return;
      stopAutoplay();
      timer = window.setInterval(() => {
        if (paused) return;
        nextPage();
      }, interval);
    }

    function stopAutoplay() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    if (pauseHover) {
      section.addEventListener("mouseenter", () => (paused = true));
      section.addEventListener("mouseleave", () => (paused = false));
    }

    // ---- Init ----
    recalc(false);
    scrollToPage(0, "auto");
    startAutoplay();

    // ---- Resize ----
    let r = null;
    window.addEventListener(
      "resize",
      () => {
        if (r) return;
        r = requestAnimationFrame(() => {
          r = null;
          const keep = activePage;
          recalc(true);
          scrollToPage(keep, "auto");
        });
      },
      { passive: true }
    );
  });
})();
